<template>
    <li>
        <router-link :class="'menu-link' + (isLocked ? ' locked' : '')"
                     :to="link"
                     :data-tooltip="tooltip"
                     @click.prevent="this.focus">
            <i class="material-icons locked notranslate" v-if="isLocked">lock</i>
            <div class="alert" v-if="alert"></div>
            <i class="material-icons menu-icon notranslate">{{ icon }}</i>
            <span>{{ text }}</span>
            <div class="ripple"></div>
        </router-link>
    </li>
</template>

<script>
export default {
  name: 'MenuLink',
  props: {
    text: String,
    tooltip: String,
    icon: String,
    link: String,
    memberOnly: Boolean
  },
  computed: {
    isLocked: function () {
      if (this.memberOnly) {
        return this.$store.state.user['is_active']
          ? !this.$store.state.user['is_active']
          : true
      } else {
        return false
      }
    },
    alert: function () {
      switch (this.link) {
        case '/awards':
          if (this.$store.state.user['current_awards']) {
            return (this.$store.state.user['current_awards'].length > 0)
          } else {
            return false
          }
        case '/payments':
          if (this.$store.state.segments && Array.isArray(this.$store.state.segments)) {
            return (this.$store.state.segments.filter(segment =>
              segment.status === 'file_sent' ||
              segment.status === 'payment_pending' ||
              segment.status === 'renewal' ||
              segment.status === 'overdue' ||
              segment.status === 'inactive'
            ).length >= 1)
          } else {
            return false
          }
        default: return false
      }
    }
  }
}
</script>

<style lang="scss">
    %transition {
        transition:
            opacity 0.3s cubic-bezier(0.4, 0.0, 0.2, 1),
            transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
    }
    @keyframes menu-ripple-effect {
        0% {
            transform: scale(0);
            opacity: 0;
        }
        50% {
            opacity: 0.38;
        }
        100% {
            transform: scale(1.75);
            opacity: 0;
        }
    }
    @keyframes menu-click {
        0% {
            transform: scale(1.0);
        }
        60% {
            transform: scale(1.15);
        }
        100% {
            transform: scale(1.0);
        }
    }
    .menu-link {
        display: block;
        position: relative;
        text-align: center;
        text-decoration: none;
        color: #000;
        @extend %transition;
        &.locked {
            cursor: not-allowed;
            opacity: 0.6;
        }
        .menu-icon {
            font-size: 32px;
            display: block;
            opacity: 0.38;
            @extend %transition;
        }
        .locked {
            position: absolute;
            top: 0;
            right: 10px;
            font-size: 18px;
            opacity: 0.7;
        }
        .alert {
            position: absolute;
            width: 12px;
            height: 12px;
            background: var(--warning-color);
            top: 0;
            left: calc(50% + 18px);
            border-radius: 50%;
        }
        span {
            font-size: 16px;
            line-height: 16px;
            padding: 4px 0;
            display: block;
            font-weight: 500;
            opacity: 0.54;
            @extend %transition;
        }
        .ripple {
            position: absolute;
            z-index: -1;
            background: var(--accent-color);
            opacity: 0;
            width: 72px;
            height: 72px;
            top: 50%;
            left: 50%;
            margin-left: -36px;
            margin-top: -36px;
            border-radius: 50%;
            cursor: none;
        }
        &:hover {
            i, span {
                opacity: 0.87;
            }
        }
        &.router-link-active {
            color: var(--accent-color);
            i, span {
                opacity: 1;
            }
            .ripple {
                animation-play-state: initial;
            }
        }
    }
    @media only screen and (max-width: 1259px) {
        .menu-link::before {
            content: '';
            display: block;
            position: absolute;
            width: 0;
            height: 0;
            border-top: 12px solid transparent;
            border-right: 12px solid transparent;
            border-bottom: 12px solid transparent;
            border-left: 12px solid #fff;
            top: 50%;
            transform: translateY(-50%);
            left: calc(100% + 12px);
        }
        .menu-link::after {
            width: 350px;
            font-size: 15px;
            line-height: 22px;
            color: #fff;
            content: attr(data-tooltip);
            font-weight: 400;
            position: absolute;
            top: 50%;
            text-align: justify;
            transform: translateY(-50%);
            left: calc(100% + 36px);
        }
    }
    @media only screen and (min-width: 1260px) {
        %animate_visibility_off {
            visibility: hidden;
            opacity: 0;
            transition: visibility 0s linear 0.2s,opacity 0.2s linear;
        }
        %animate_visibility_on {
            visibility: visible;
            opacity: 1;
            transition-delay: 0s;
        }
        .menu-link::before {
            content: '';
            display: block;
            position: absolute;
            width: 0;
            height: 0;
            border-top: 12px solid transparent;
            border-right: 12px solid #424242;
            border-bottom: 12px solid transparent;
            border-left: 12px solid transparent;
            top: 18px;
            transform: translateY(-50%);
            left: calc(100% - 24px);
            @extend %animate_visibility_off;
        }
        .menu-link::after {
            width: 324px;
            color: #fff;
            background: #424242;
            padding: 6px;
            border-radius: 8px;
            content: attr(data-tooltip);
            font-weight: 400;
            position: absolute;
            top: 18px;
            transform: translateY(-50%);
            left: 100%;
            @extend %animate_visibility_off;
        }
        .menu-link:not(:focus):hover::before,
        .menu-link:not(:focus):hover::after {
            @extend %animate_visibility_on;
        }
        .menu-link:focus,
        .menu-link:active {
            animation-name: menu-click;
            animation-duration: 0.6s;
            animation-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);
            .ripple {
                animation-name: menu-ripple-effect;
                animation-duration: 0.45s;
                animation-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);
            }
        }
    }
</style>
